import React from 'react';

export interface ColumnProps {
  name: string;
  label?: string;
  className?: string;
  dataIndex?: string;
  align?: string;
  render?: (data: any) => void;
}

class Column extends React.Component<ColumnProps> {
  public getLabel() {
    return this.props.label;
  }

  public render() {
    return <div />;
  }
}

export default Column;
